import { useEffect, useState } from "react";
import API from "../../services/api";

function Profile() {

  const [user, setUser] = useState({

    name: "",

    email: "",

    phone: ""

  });

  useEffect(() => {

    fetchProfile();

  }, []);

  // ==========================
  // Fetch Profile
  // ==========================

  const fetchProfile = async () => {

    try {

      const res = await API.get("/user/profile");

      setUser(res.data.user);

    } catch (error) {

      console.log(error);

    }

  };

  // ==========================
  // Update Profile
  // ==========================

  const updateProfile = async () => {

    try {

      await API.put(

        "/user/profile",

        {

          name: user.name,

          phone: user.phone

        }

      );

      alert("✅ Profile Updated Successfully");

    } catch (error) {

      console.log(error);

      alert(

        error.response?.data?.message ||

        "Profile Update Failed"

      );

    }

  };

  return (

    <div className="form-container">

      <h2>

        👤 My Profile

      </h2>

      <input

        type="text"

        value={user.name}

        placeholder="Full Name"

        onChange={(e)=>

          setUser({

            ...user,

            name:e.target.value

          })

        }

      />

      <input

        type="email"

        value={user.email}

        disabled

      />

      <input

        type="text"

        value={user.phone}

        placeholder="Phone Number"

        onChange={(e)=>

          setUser({

            ...user,

            phone:e.target.value

          })

        }

      />

      <button

        onClick={updateProfile}

      >

        Update Profile

      </button>

    </div>

  );

}

export default Profile;